import * as z from "zod/v4";

export const updateLinearTicketStatus = {
  name: "updateLinearTicketStatus" as const,
  input: z.object({ linearTicketId: z.string(), newStateId: z.string() }),
  output: z.object({
    success: z.boolean(),
    newStateName: z.string().nullable(),
  }),
};
